import React, { Component, PropTypes } from 'react';
import LeafletMap from './LeafletMap';

class SitesMap extends Component {
    render() {
        return (
            <div className="col-sm-7 map-container">
                <LeafletMap sites={this.props.sites}
                            activeSite={this.props.activeSite}
                            markerActivated={this.props.markerActivated}/>
            </div>

    );
    }

}

SitesMap.propTypes = {
    sites: PropTypes.object,
    activeSite: PropTypes.object,
    markerActivated: PropTypes.func
};

export default SitesMap;


// WEBPACK FOOTER //
// ./src/map/SitesMap.js